<template>
  <v-data-table
    class="main-table"
    :headers="headers"
    :items="checklist"
    hide-default-footer
    disable-sort
    :options="tableOptions"
  >
    <!-- Note, we need items slot for row level class until https://github.com/vuetifyjs/vuetify/issues/8643 is implemented -->
    <template v-slot:item="{ item }">
      <tr
        :class="getAlertClass(item.completionStatus.name)"
        :key="item.evdViewName"
      >
        <td>
          <span
            class="dot mr-1"
            :class="getStatusColor(item.completionStatus.name)"
          ></span>
          {{ item.completionStatus.desc }}
        </td>
        <td>{{ item.name }}</td>
        <td>{{ item.dueDate | formatDate }}</td>
        <td class="text-right">
          <v-btn
            height="32px"
            min-width="32px"
            :to="getLink(item)"
            @click.native="
              logEvent('Opened EVD item', {
                ItemName: item.name,
                Client: item.clientName,
                Status: item.completionStatus.desc
              })
            "
            class="tertiary"
            depressed
          >
            <v-icon color="primary">mdi-arrow-right</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import hasStatusFactory from "@/mixins/has-status-factory";
import { get } from "@/services/request";
import { customerChecklistAPI } from "@/services/api";
import { getChecklistItemLink } from "@/services/util";

const tableOptions = {
  itemsPerPage: -1
};

const statusColorMap = {
  REVISION_NEEDED: "warning",
  NOT_STARTED: "error",
  INCOMPLETE: "error",
  COMPLETE: "success"
};

export default {
  name: "CustomerTodos",
  props: ["customerId"],
  mixins: [hasStatusFactory(statusColorMap)],
  created: function() {
    this.loadChecklist();
  },
  data: () => ({
    headers: [
      {
        text: "Status",
        value: "completionStatus"
      },
      { text: "Item", value: "name" },
      { text: "Due Date", value: "dueDate" },
      { text: " ", value: "action", align: "end" }
    ],
    checklist: [],
    tableOptions,
    statusColorMap
  }),
  filters: {
    formatDate(val) {
      if (val) {
        return (
          val.substring(5, 7) +
          "/" +
          val.substring(8, 10) +
          "/" +
          val.substring(0, 4)
        );
      }
    }
  },
  methods: {
    loadChecklist() {
      return get(
        customerChecklistAPI.getUrl({ customerId: this.customerId })
      ).then(response => {
        if (response && response.data) {
          this.checklist = response.data;
        }
      });
    },
    getLink(item) {
      return getChecklistItemLink(item, this.customerId);
    }
  }
};
</script>

<style lang="sass" scoped></style>
